__webpack_require__.p = "/pipeline-templates/onboarding/";